import { useEffect } from 'react'
import { useRouter } from 'next/router'

import accountAnalytics from '~/analytics/account/accountAnalytics'
import { useGetMeQueryState } from '~/redux/apis/user-api'
import { identifyUserWithPosthog } from '~/utils/analytics/posthogUtils'

export default function useInitApp(): void {
  const { isSuccess, data } = useGetMeQueryState()
  const { locale } = useRouter()

  useEffect(() => {
    if (isSuccess && data) {
      accountAnalytics.logAuthenticateWithToken(data.log)

      identifyUserWithPosthog(data, locale)
    }
  }, [isSuccess, data, locale])
}
